import { Injectable } from '@angular/core';
import { TravelSchedulerDTO } from '../interfaces/travel-scheduler/travel-scheduler-task';
import { ISupplierRiskManagementDTO } from '../interfaces/supplier-risk-management/supplier-risk-management';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { TaskReviewStatus } from '../enums/supplier-risk-management/task-review-status';
import { ISupplierRiskManagementSearch } from '../interfaces/supplier-risk-management/supplier-risk-management-search';
import { ISupplierRiskManagementFilterDto } from '../interfaces/supplier-risk-management/supplier-risk-management-filter-dto';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng';
import { Message } from '../classes/Message';
import { ISupplierRiskManagementAssigneeCounts } from '../interfaces/supplier-risk-management/supplier-risk-management-assignee-counts';
import {
  IUnscheduledTaskFilterOptionsDto,
  IUnscheduledTasksDTO,
} from '../interfaces/supplier-risk-management/unscheduled-tasks';
import { IUnscheduledTasksSearch } from '../interfaces/supplier-risk-management/unscheduled-tasks-search';
import {
  IAssignmentHistoryDTO,
  IAssignmentHistoryFilterOptionsDto,
} from '../interfaces/supplier-risk-management/assignment-history';
import { IAssignmentHistorySearch } from '../interfaces/supplier-risk-management/assignment-history-search';

@Injectable({
  providedIn: 'root',
})
export class SupplierRiskManagementService extends BaseDataService {
  public url = '/api/supplier-risk-management';
  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAssigneeCounts() {
    return this.http.get<ISupplierRiskManagementAssigneeCounts>(this.url + '/counts').toPromise();
  }

  public getFilterOptions() {
    return this.http
      .get<ISupplierRiskManagementFilterDto>(this.url + '/filter-options')
      .toPromise();
  }

  public get(request: ISupplierRiskManagementSearch): Promise<ISupplierRiskManagementDTO> {
    let params = this.constructHttpParams(request);

    return this.http.get<ISupplierRiskManagementDTO>(this.url, { params: params }).toPromise();
  }

  public getUnscheduledTasks(request: IUnscheduledTasksSearch): Promise<IUnscheduledTasksDTO> {
    let params = this.constructHttpParams(request);

    return this.http
      .get<IUnscheduledTasksDTO>(this.url + '/unscheduled-tasks', { params: params })
      .toPromise();
  }

  public getUnscheduledTasksFilterOptions(): Promise<IUnscheduledTaskFilterOptionsDto> {
    return this.http
      .get<IUnscheduledTaskFilterOptionsDto>(this.url + '/unscheduled-tasks/filter-options')
      .toPromise();
  }

  public getUnscheduledTasksCount(): Promise<number> {
    return this.http.get<number>(this.url + '/unscheduled-tasks/count').toPromise();
  }

  public getAssignmentHistory(request: IAssignmentHistorySearch): Promise<IAssignmentHistoryDTO> {
    let params = this.constructHttpParams(request);

    return this.http
      .get<IAssignmentHistoryDTO>(this.url + '/assignment-history', { params: params })
      .toPromise();
  }

  public getAssignmentHistoryFilterOptions(): Promise<IAssignmentHistoryFilterOptionsDto> {
    return this.http
      .get<IAssignmentHistoryFilterOptionsDto>(this.url + '/assignment-history/filter-options')
      .toPromise();
  }

  public getAssignees() {
    return this.http.get<SelectItem[]>(this.url + '/assignees').toPromise();
  }
  public async assignUser(supplierId: number, assigneeId: string) {
    return await this.http
      .put(this.url + `/assign?supplierId=${supplierId}&assigneeId=${assigneeId}`, {})
      .toPromise();
  }

  public async unassignUser(supplierId: number) {
    return await this.http.put(this.url + `/unassign?supplierId=${supplierId}`, {}).toPromise();
  }

  public async unassignAll() {
    return await this.http.post(this.url + `/unassign/all`, null).toPromise();
  }

  public async unassignMe() {
    return await this.http.post(this.url + `/unassign/me`, null).toPromise();
  }

  public async beginTaskReview(taskId: number) {
    return await this.http.get(this.url + `/review/begin?taskId=${taskId}`).toPromise();
  }

  public async completeTaskReview(taskId: number) {
    return await this.http.get(this.url + `/review/complete?taskId=${taskId}`).toPromise();
  }
}
